// UAT RBAC-UX-05 (2026-07-14) — Business Persona derivation for role codes.
//
// Displayed on the Users list beside the Role name. This is a pure
// presentation layer — no backend / registry contract change. The map
// intentionally lives on the frontend so business labels can evolve
// without touching the frozen RBAC architecture.
//
// Fallback order:
//   1. Explicit persona in the map below.
//   2. The role.description field (if the caller passes a live role object).
//   3. The role code itself (last-resort).
//
// Extending the map is safe. Removing entries is safe.

export const ROLE_PERSONA_MAP = {
    super_admin: "Primary Administrator",
    accounts: "Accounts Team",
    sales: "Sales Representative",
    viewer: "Read-Only Observer",
    data_user: "Data Operator",
    logo_user: "Logo Repository Operator",
    // Common custom roles observed in production DB (2026-07-14).
    hr_user: "HR Administrator",
    operations_user: "Operations Team",
    developer: "Engineering",
    data_sales: "Sales & Data (Cross-functional)",
    support: "Customer Support",
    dash_no_perm: "No-Access Placeholder",
};

export function rolePersonaLabel(roleCode, roleObject) {
    if (!roleCode) return "—";
    if (ROLE_PERSONA_MAP[roleCode]) return ROLE_PERSONA_MAP[roleCode];
    if (roleObject && typeof roleObject.description === "string" && roleObject.description.trim().length > 0) {
        return roleObject.description.trim();
    }
    return "Custom Role";
}
